import React, { useState } from "react";
import { Plus } from "lucide-react";

const FAQS = [
  { q: "What does it cost?", a: "$250 per week + GST, billed weekly — no setup fee, no lock-in contract, cancel any time. That covers the whole done-for-you system: strategy, exterior-cleaning ad creative, copy, launch, ongoing management, LEO (your AI follow-up teammate), 7FC Job Hub, automated SMS and email follow-up, and campaign optimisation. Ad spend is separate and always paid by you directly to Meta on your own account (we recommend from about $30 per day)." },
  { q: "Is there a lock-in contract?", a: "No. Everything is week to week — keep going for as long as it is working for you, or cancel any time. No setup fee, no lock-in period, no exit fees." },
  { q: "What is included?", a: "Meta advertising strategy and management, exterior-cleaning ad creative and copy, service-specific landing pages, LEO AI follow-up and qualification, automated SMS and email follow-up, the 7FC Job Hub, a simple lead and quote pipeline, lost-enquiry reactivation, campaign optimisation, performance reporting, and direct support from Chris." },
  { q: "Who do you work with?", a: "Established exterior cleaners across Australia — house washing, roof washing, soft washing and pressure cleaning. Pool cleaning is also supported as part of the broader offering. One suitable operator per territory." },
  { q: "How much should I spend on ads?", a: "We recommend a minimum of about $30 per day to give the campaign room to learn. Your ad spend is always your own, billed directly by Meta and separate from our management fee. We help you tune it to your service area and how many enquiries your team can handle." },
  { q: "What is the guarantee?", a: "If your campaign does not generate 30 eligible local enquiries during its first 30 days live, we will continue managing it without charging our weekly management fee until it does. An eligible enquiry is a genuine person requesting an exterior-cleaning service, located within the agreed service territory, requesting a service included in the campaign, providing usable contact information, and generated exclusively for you." },
];

const MeetAndFAQ = () => {
  const [open, setOpen] = useState(0);

  // FAQPage structured data — helps Google surface rich snippets in SERPs
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="about" className="bg-gray-50/70 py-14 sm:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <h2 id="faq" className="text-3xl font-black uppercase tracking-tight text-brand-black sm:text-4xl">
              Frequently Asked <span className="text-brand-blue">Questions</span>
            </h2>
          </div>
          <div className="mt-10">
            <ul className="flex flex-col gap-2.5">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <li key={f.q} className="overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-200">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 p-4 text-left transition-colors hover:bg-gray-50/60"
                    >
                      <span className="text-sm font-semibold text-brand-black sm:text-base">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-blue/10 text-brand-blue transition-transform ${
                          isOpen ? "rotate-45" : ""
                        }`}
                      >
                          <Plus className="h-3.5 w-3.5" />
                        </span>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ${
                          isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <div className="border-t border-gray-100 p-4 text-sm leading-relaxed text-[#374151]">
                            {f.a}
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </section>
    );
};

export default MeetAndFAQ;
